import websiteData = require("diy/util/websiteData");
import NotificationApi from "diy/toolbar/notificationNG/Api";
import NotificationType from "diy/toolbar/notificationNG/definitions/Type";

import Status from "../Status";
import Backend from "../Backend";
import DataStorage from "../DataStorage";
import {NotificationData, Observer} from "../Notifier";

export default class NotificationCenterObserver implements Observer {
    actionHandler: () => void;
    dismissHandler: () => void;

    notify(data: NotificationData) {
        let lastNotificationBubbled = DataStorage.getLastNotificationBubbled();
        DataStorage.setLastNotificationBubbled(data.status);

        NotificationApi.schedule(() => {
            switch (data.status) {
                case Status.INITIAL:
                    this.dismissHandler = () => {
                        Backend.skipExternalImport(websiteData.getId());
                    };
                    this.actionHandler = data.actionHandler;

                    NotificationApi.pushOne({
                        type: NotificationType.EXTERNAL_WEBSITE_IMPORT_STARTED,
                        dismissed: false
                    });
                    break;

                case Status.SKIPPED:
                    this.actionHandler = data.actionHandler;

                    NotificationApi.pushOne({
                        type: NotificationType.EXTERNAL_WEBSITE_IMPORT_SKIPPED,
                        dismissed:
                            ((lastNotificationBubbled === data.status) &&
                            (Status.SKIPPED !== data.status))
                    });
                    break;

                case Status.SUCCESS:
                    this.actionHandler = () => {
                        diy.editor.deeplinking.requestPath([
                            {label: 'siteadmin', params: 'pages'}
                        ]);
                    };
                    NotificationApi.pushOne({
                        type: NotificationType.EXTERNAL_WEBSITE_IMPORT_FINISHED
                    });
                    NotificationApi.deleteOne(
                        NotificationType.EXTERNAL_WEBSITE_IMPORT_SKIPPED
                    );
                    break;

                default:
                    break;
            }
        });
    }

    remove() {
        NotificationApi.schedule(() => {
            NotificationApi.deleteOne(
                NotificationType.EXTERNAL_WEBSITE_IMPORT_STARTED
            );
            NotificationApi.deleteOne(
                NotificationType.EXTERNAL_WEBSITE_IMPORT_SKIPPED
            );
            NotificationApi.deleteOne(
                NotificationType.EXTERNAL_WEBSITE_IMPORT_FINISHED
            );
        });
    }

    getActionHandler(): () => void {
        return this.actionHandler;
    }
}

export let notificationCenterObserver = new NotificationCenterObserver;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/NotifierObservers/NotificationCenterObserver.ts
 **/